import React, { useMemo } from 'react';
import { Box, Inscription, RoundDoneIcon } from '@common-fe/common-fe';

interface Props {
  planName?: string;
  planNames?: string[];
  isBulkMode?: boolean;
  testId?: string;
}

export const ResumeHeader: React.FC<Props> = ({ 
  planName,
  planNames,
  isBulkMode = false,
  testId = 'ResumeHeader' 
}) => {
  const title = useMemo(() => {
    if (isBulkMode && planNames) {
      return `Reactivation request sent for: ${planNames.join(', ')}`;
    }
    return `Reactivating ${planName || 'Plan'}`;
  }, [isBulkMode, planNames, planName]);

  const description = useMemo(() => {
    const planText = isBulkMode ? 'plans are' : 'plan is';
    return `The ${planText} being reactivated with their previous settings.\nSee the additional steps below to complete setup.`;
  }, [isBulkMode]);

  return (
    <>
      <Box align="center" margin={{ top: 'spacing24', bottom: 'spacing12' }} data-testid={`${testId}_icon-container`}>
        <RoundDoneIcon />
      </Box>

      <Box align="center" margin={{ bottom: 'spacing12' }}>
        <Inscription textAlign="center" lineHeight="32px" weight="bold" size="2xl" data-testid={`${testId}_title`}>
          {title}
        </Inscription>
      </Box>

      <Box align="center" margin={{ bottom: 'spacing12' }}>
        <Inscription textAlign="center" data-testid={`${testId}_description`} style={{ whiteSpace: 'pre-line' }}>
          {description}
        </Inscription>
      </Box>
    </>
  );
};
